
export const imageSrc = [
    { 
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car.png`,
    },
    { 
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fashion.png`,
    },
    
    { 
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/fabric.png`,
    },
    { 
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/furnishing.png`,
    },
    { 
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/food.png`,
    },
    { 
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/footwear.png`,
    },
    { 
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/product.png`,
    },
    
    { 
      type:`home banner image - 7`,
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/home-banner.png`,
    },
    {  type:`trusted clients image - 8`,
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client1.png`,
    },
    {  
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client2.png`,
    },
    {  
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client3.png`,
    },
    {  
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client4.png`,
    },
    {  
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client5.png`,
    },
    {  
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client6.png`,
    },
    {  
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/car-n-bike.png`,
    },
    {  
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/karvi-client.png`,
    },
    {  
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client9.png`,
    },
    {  
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client10.png`,
    },
    {  
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/client11.png`,
    },
    {  //19
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/Star-bg.png`,
    },
    {  type:`web check image - 20`,
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/check.png`,
    },
    {  type:`web image - 21`,
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/web-img.png`,
    },
    {  type:`Real stories image - 22`,
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/slide.png`,
    },
    {  type:`Double qoutes image - 23`,
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/qoutes.png`,
    },
    {  type:`Mobile App image - 24`,
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/mobile-app.png`,
    },
    {  type:`Double qoutes image - 25`,
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/web-app.png`,
    },
    {  type:`Double qoutes image - 26`,
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/api.png`,
    },
    {  type:`Double qoutes image - 27`,
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/dashboard.png`,
    },
    {  type:`mobile-app left image - 28`,
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/mobile-img.png`,
    },
// Accordion Images 
    {  type:` image - 29`,
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord1.png`,
    },
    { type:`image - 30`,
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord2.png`,
    },
    {  type:`image - 31`,
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord3.png`,
    },
    {  type:`image - 32`,
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord01.png`,
    },
    {  type:`image - 33`,
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord02.png`,
    },
    {  type:`image - 34`,
      src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord03.png`,
    },

    {  type:`image - 35`,
    src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/accord-dot.png`,
  },

  {  type:`template right bg image - 36`,
    src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/template-right-bg.png`,
  },
  {  type:`image - 37`,
    src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/temp-dots.png`,
  },
  {  type:`Dashboard middle image - 38`,
  src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/dash-middle.png`,
},
{  type:`book demo modal image - 39`,
  src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/user(Traced).png`,
},
{  type:`book demo modal image - 40`,
  src: `${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/SpyneHome-v2/solution(Traced).png`,
},
]